import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { deleteApi, getApi } from "../../utils/api";
import { API_EXPERIENCE } from "../../config/Endpoints";
import { showSuccess, showError } from "../../v2/utils/toast.ts";
import AddWorkExperience from "./AddWorkExperience";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import { displayFormatDate } from "../../utils/helpers";
import SortableTable from "../../components/SortableTable";
import TruncateText from "../../components/TruncateText";

const WorkExperience = ({ workData }) => {
  const [experienceList, setExperienceList] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [selectedWork, setSelectedWork] = useState({});
  const [selectedWorkId, setSelectedWorkId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { key: "jobTitle", label: "Job Title" },
    { key: "previousCompany", label: "Previous Company" },
    {
      key: "fromDate",
      label: "From",
      compare: (a, b) => new Date(a.fromDate) - new Date(b.fromDate),
      render: (item) => displayFormatDate(item.fromDate),
    },
    {
      key: "toDate",
      label: "To",
      compare: (a, b) => new Date(a.toDate) - new Date(b.toDate),
      render: (item) => displayFormatDate(item.toDate),
    },
    {
      key: "jobDescription",
      label: "Description",
      sortable: false,
      render: (item) => (
        <TruncateText text={item.jobDescription?.trim() || "-"} />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (item) => (
        <>
          <div className="d-flex align-items-center gap-3">
            <a href="javascript:void(0)" onClick={() => handleView(item)}>
              Edit
            </a>

            <a
              href="javascript:void(0)"
              onClick={() => handleDeleteAlert(item.experienceId)}
              className="text-danger"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropExperienceDelete"
            >
              Delete
            </a>
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    setExperienceList(workData);
  }, [workData]);

  const handleDelete = () => {
    setIsLoading(true);
    deleteApi(API_EXPERIENCE + `/${selectedWorkId}`, accessToken)
      .then((res) => {
        if (res.status === 200) {
          let newArray = experienceList.filter(
            (item) => item.experienceId !== selectedWorkId,
          );
          setExperienceList(newArray);
          setIsLoading(false);
          const modalClose = document.getElementsByClassName(
            "cancel-modal-experience-delete",
          )[0];
          modalClose.click();
          showSuccess(res.data.message);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const handleView = (item) => {
    setSelectedWork(item);
  };
  const handleDeleteAlert = (id) => {
    setSelectedWorkId(id);
  };

  return (
    <>
      {experienceList?.length === 0 ? (
        <div className="fs-4 text-secondary text-center">
          No records available
        </div>
      ) : (
        <SortableTable
          className="resume custom"
          data={experienceList}
          columns={columns}
        />
      )}

      <button
        className="theme-button mt-3 p-2  add-experience"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropExperience"
      >
        + Add Experience
      </button>

      <div
        className="modal fade"
        id="staticBackdropExperience"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <AddWorkExperience
              setExperienceList={setExperienceList}
              selectedWork={selectedWork}
              setSelectedWork={setSelectedWork}
            />
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdropExperienceDelete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="text-center">
                Are you sure you want to delete this work experience?
              </h5>
            </div>
            <div className="justify-content-center modal-footer">
              <button
                type="button"
                className={
                  isLoading ? "theme-button disabled " : "theme-button "
                }
                onClick={handleDelete}
              >
                {isLoading ? (
                  <ThreeDots
                    height="20"
                    width="53"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  "Yes"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3 w-35 cancel-modal-experience-delete"
                data-bs-dismiss="modal"
                onClick={() => setSelectedWorkId("")}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkExperience;
